import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'space-around',
        height: 'auto',
        width: 'auto',
        color: theme.palette.secondary.main,
    },
    title: {
        paddingTop: 30,
        paddingBottom: 10,
        textAlign: 'center'
    },
    graphContainer: {
        width: '100%'
    },
    message: {
        width: '90%',
        textAlign: 'center',
        fontSize: 18
    },
    hiddenChart: {
        position: 'absolute',
        opacity: 0,
        pointerEvents: 'none',
        width: 1000,
        color: 'black',
    },
    footer: {
        paddingTop: theme.spacing(5),
        width: '75%',
        '& .MuiButton-root': {
            marginBottom: theme.spacing(1)
        }
    },
    buttonProgress: {
        color: theme.palette.secondary.main,
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },
    openChart: {
        width: '100%',
        color: 'black',
    }
}));

export default useStyles;
